import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { ProcessamentoIACriteria } from "@workflow/types";

import { processamentoIAService } from "@/services/api/processamento-ia.service";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;
const ESTATISTICAS_STALE = 2 * MINUTE;

/**
 * Fonte de verdade das query keys do domínio "processamento-ia". `resumo` e
 * `detail` mantêm as keys legadas (lidas pelos KPIs e pelo diálogo de detalhes);
 * `all` cobre lista + filtros.
 */
export const processamentoIaKeys = {
  all: ["processamentos-ia"] as const,
  lists: () => [...processamentoIaKeys.all, "list"] as const,
  list: (criteria: ProcessamentoIACriteria) => [...processamentoIaKeys.lists(), criteria] as const,
  filtros: () => [...processamentoIaKeys.all, "filtros"] as const,
  resumo: ["processamento-ia-resumo"] as const,
  estatisticas: ["processamentos-ia", "estatisticas"] as const,
  detail: (id: number) => ["processamento-ia", id] as const,
};

export const processamentoIaQueries = {
  list: (criteria: ProcessamentoIACriteria) =>
    queryOptions({
      queryKey: processamentoIaKeys.list(criteria),
      queryFn: () => processamentoIAService.list(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: processamentoIaKeys.filtros(),
      queryFn: () => processamentoIAService.getFiltros(),
      staleTime: FILTROS_STALE,
    }),

  estatisticas: () =>
    queryOptions({
      queryKey: processamentoIaKeys.estatisticas,
      queryFn: () => processamentoIAService.estatisticas(),
      staleTime: ESTATISTICAS_STALE,
    }),
};
